































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { QuestionnairesService } from "@/services/Questionnaires.service.ts";
import Number from "@/shared/filters/Number";
import InputNumber from "@/views/components/input/InputNumber.vue";
import InputString from "@/views/components/input/InputString.vue";
import Pagination from "@/views/components/Pagination.vue";
import vuedraggable from "vuedraggable";
import { KyotenData } from "@/models/KyotenData";

@Component({
  filters: {
    Number
  },
  components: {
    InputNumber,
    InputString,
    Pagination,
    draggable: vuedraggable
  }
})
export default class QuestionnaireDetail extends Vue {
  @Prop({ default: "" })
  title: string;
  public questionnairesService = new QuestionnairesService();
  public questionData: any;
  public questionEdit: any;
  public questionList: any[] = [];
  public questionItemList: any[] = [];

  public itemSizes: any[] = [
    { label: "10件", value: 10 },
    { label: "20件", value: 20 },
    { label: "50件", value: 50 },
    { label: "100件", value: 100 }
  ];
  public itemSizeSelected: number = 10;
  private loading: boolean = false;
  public kyotenDataList: KyotenData[] = [];
  public form: any = {
    kyotenSelected: ""
  };
  public dialogFormVisible: boolean = false;
  maxQuestion: number = 10;
  disableBtnAdd: boolean = true;
  timerReOrder: any = null;

  get questionIndex() {
    let id: number = 0;
    if (this.questionList.length !== 0) {
      id = +this.questionList[this.questionList.length - 1].id;
    }
    return id + 1;
  }

  constructor() {
    super();

    this.questionData = {
      id: "",
      topic: ""
    };

    this.questionEdit = {
      id: "",
      topic: ""
    };
  }

  public delay(time: number) {
    setTimeout(() => {
      this.loading = false;
    }, time);
  }

  public onSubmit() {
    if (this.questionData.topic) {
      this.loading = true;
      const data = {
        ...this.questionData,
        id: null
      };
      this.addQuestionItem({ ...data });
    }
  }

  public async getKyotenDataList() {
    const response = await this.questionnairesService.getKyotens();
    if (response) {
      this.$set(this, "kyotenDataList", response);
    }
  }

  public async selectKyoten() {
    this.loading = true;
    const data = this.kyotenDataList.filter(
      (e: any) => e.staffCd === this.form.kyotenSelected
    );
    this.getQuestionList(this.form.kyotenSelected);
    this.delay(1000);
  }

  public async getQuestionList(kyoten: string, id?: number) {
    const response = await this.questionnairesService.getQuestions(kyoten, id);
    if (response) {
      const data = response.map((e: any) => {
        return { ...e, isEdit: false };
      });
      this.$set(this, "questionList", [...data]);
    } else {
      this.$set(this, "questionList", []);
    }
    this.checkDisabledAdd();
  }

  public async addQuestionItem(data: any) {
    const response = await this.questionnairesService.editQuestion(data);
    if (response) {
      this.getQuestionList(this.form.kyotenSelected);
      this.delay(1000);
    } else {
      console.log(response);
      this.delay(1000);
    }
  }

  public async delQuestionItem(id: number) {
    this.loading = true;
    const response = await this.questionnairesService.deleteQuestion(id);
    if (response === 200) {
      this.getQuestionList(this.form.kyotenSelected);
      this.delay(1000);
    } else {
      console.log(response);
      this.delay(1000);
    }
  }

  public showEditDialog(rowData: any) {
    this.dialogFormVisible = true;
    this.questionEdit = { ...rowData };
  }

  public editQuestionItem() {
    this.loading = true;
    if (this.questionEdit.id && this.questionEdit.topic) {
      const data = {
        id: this.questionEdit.id,
        topic: this.questionEdit.topic
      };
      this.addQuestionItem({ ...data });
    }
    this.dialogFormVisible = false;
  }

  private mounted() {
    // this.getKyotenDataList();
    // this.form.kyotenSelected = localStorage.getItem("kyotenCd");
    this.getQuestionList(this.form.kyotenSelected);
  }

  checkDisabledAdd() {
    let disabled = false;
    if (this.questionList.length >= this.maxQuestion) {
      disabled = true;
    } else if (this.questionData.topic === "") {
      disabled = true;
    }

    this.$set(this, "disableBtnAdd", disabled);
  }

  onEnd(event: any) {
    if (this.timerReOrder) {
      clearTimeout(this.timerReOrder);
      this.timerReOrder = null;
    }
    this.timerReOrder = setTimeout(() => {
      const data = this.questionList.map((e: any) => {
        let item = { ...e };
        delete item.isEdit;
        return item;
      });
      this.saveQuestionList(data);
    }, 1000);
  }

  public async saveQuestionList(data: any[]) {
    const response = await this.questionnairesService.saveQuestions(data);
    if (response) {
      console.log(response);
    }
  }
}
